import app, { Component } from 'apprun';
import { isStringEqual, } from '../utils';
import { lookup_en } from '../utils';
import { users } from '../api';

export default class CommonPropertyComponent extends Component {
  state = { selectOptions: [], auditLog: [] };

  view = (state) => {
    if (!state.item) {return;}
    return (
      <form class="form-horizontal" style={{ width: '450px' }}>
        <div class="row">
          <div class="col-sm-12">{state.item.dispName}</div>
          {
            <div class="col-sm-12">
              <select id="inpText" class="form-control" oninput={e => (state.newVal = e.target.value)}>
                {state.selectOptions.map(p => (
                  <option
                    value={p.id}
                    selected={isStringEqual(p.id, state.newVal.toString().split(' - ')[0])?'selected':null}>
                    {p.value}
                  </option>
                ))}
              </select>
            </div>
          }
        </div>
        <div id="inpTextErrMsg" class="text-danger"></div>
        <div class="edit-buttons">
          <a
            type="button"
            class="btn btn-primary btn-xs"
            style={
              state.item.required || state.item.value === ''
                ? { display: 'none' }
                : { display: 'inline-block' }
            }
            onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
          </a>
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
          </a>
          <a
            type="button"
            class="btn btn-default btn-xs"
            onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>

        {state.item.fieldName === 'Employeetype' && state.personId?
          <div>
            <p>Update History</p>
            <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover" style=" white-space: normal;">
              <thead>
                <tr>
                  <th>Employee Type</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Modified Date</th>
                  <th>Modified User</th>
                </tr>
              </thead>
              <tbody>
                {state.auditLog.map((item) => {
                  return (
                    <tr style={{ display: 'table-row' }}>
                      <td>{item.employeeType}</td>
                      <td>{item.startDate?.substring(0, 10)}</td>
                      <td>{item.endDate?.substring(0, 10)}</td>
                      <td>{item.modifiedDate?.substring(0, 10)}</td>
                      <td>{item.auditModifiedUser}</td>
                    </tr>
                  );
                }
                )}
              </tbody>
            </table></div> : ''}

        {state.item.fieldName === 'PrimaryLocation' && state.personId?
          <div>
            <p>Update History</p>
            <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover" style=" white-space: normal;">
              <thead>
                <tr>
                  <th>Location ID</th>
                  <th>Location Name</th>
                  <th>Modified Date</th>
                  <th>Modified User</th>
                </tr>
              </thead>
              <tbody>
                {state.auditLog.map((item) => {
                  return (
                    <tr style={{ display: 'table-row' }}>
                      <td>{item.locationID}</td>
                      <td>{item.locationName}</td>
                      <td>{item.modifiedDate?.substring(0, 10)}</td>
                      <td>{item.auditModifiedUser}</td>
                    </tr>
                  );
                }
                )}
              </tbody>
            </table></div> : ''}

        {state.item.fieldName === 'DisplayOnSearchInd' && state.personId ?
          <div>
            <p>Update History</p>
            <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover" style=" white-space: normal;">
              <thead>
                <tr>
                  <th>Show on public site</th>
                  <th>Modified Date</th>
                  <th>Modified User</th>
                </tr>
              </thead>
              <tbody>
                {state.auditLog.map((item) => {
                  return (
                    <tr style={{ display: 'table-row' }}>
                      <td>{item.searchIndDesp}</td>
                      <td>{item.modifiedDate?.substring(0, 10)}</td>
                      <td>{item.auditModifiedUser}</td>
                    </tr>
                  );
                }
                )}
              </tbody>
            </table></div> : ''}
      </form>
    );
  };

  update = {
    refresh: async (state, newState) => {
      state = newState;

      let selectOptions = [];
      if (state.item.fieldTypeDetail && state.item.fieldTypeDetail.startsWith('[')) {
        selectOptions = JSON.parse(state.item.fieldTypeDetail);
      } else {
        selectOptions = lookup_en[state.item.fieldTypeDetail];
      }
      selectOptions = selectOptions || [];

      if (state.personId) {
        if (state.item.fieldName === 'Employeetype') {
          state.auditLog = await users.getAuditEmployeeType(state.personId);
        } else if (state.item.fieldName === 'PrimaryLocation') {
          state.auditLog = await users.getAuditLocation(state.personId);
        } else if (state.item.fieldName === 'DisplayOnSearchInd') {
          state.auditLog = await users.getAuditPublicSiteInd(state.personId);
        }
      }

      return { ...state, selectOptions, newVal: newState.item.value };
    },

    save: (state) => {
      state.caller.run(state.save, state.item, state.panelId, state.newVal);
    },
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
